import { render } from "./ChangePasswordButton.vue?vue&type=template&id=5cd31f49"
import script from "./ChangePasswordButton.vue?vue&type=script&lang=js"
export * from "./ChangePasswordButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__